import { Auth0Provider } from "@auth0/auth0-react";
import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import LoginHandler from './components/auth0/loginHandler.jsx';
import App from './App';
import * as serviceWorker from './serviceWorker';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/fonts/googleapis-font.css';
import './assets/fonts/ionicons/css/ionicons.min.css';
import './assets/fonts/ionicons/css/ionicons.min.css';
import './assets/fonts/business-icons/font/flaticon.css';
import './assets/fonts/fontawesome/css/font-awesome.min.css';
import './assets/css/helpers.css';
import './assets/css/style.css';
import './assets/css/CideMainStyle.css';
import { AUTH0_REDIRECT_URL } from './constants';

ReactDOM.render(
  <Auth0Provider
    domain="cidemipyme.us.auth0.com"
    clientId="Hz9i5sjX1pta1XOFcXwRyAgpMWiH66m6"
    redirectUri={AUTH0_REDIRECT_URL}
  >
    <LoginHandler>
    <React.StrictMode>
      <App />
    </React.StrictMode>
    </LoginHandler>
  </Auth0Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
